<div class="card card-flush h-xl-100">
  <div class="card-body pt-5">

    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>IATF Document Management</nz-page-header-title>
      <nz-page-header-subtitle>Manage document types and versions</nz-page-header-subtitle>
      @if (permission.Add) {
        <nz-page-header-extra>
          <button nz-button nzType="primary" (click)="showModal()">Add Document Type</button>
        </nz-page-header-extra>
      }
    </nz-page-header>

    <nz-divider></nz-divider>
    <div style="padding: 8px;float:right">
      <input type="text" style="width: 250px;margin-right: 8px;" nz-input placeholder="Search name / format no"
        [(ngModel)]="searchValue" (keydown.enter)="Search()" />
      <button nz-button nzSize="small" nzType="primary" (click)="Search()"
      style="margin-right: 8px;">Search</button>
      <button nz-button nzSize="small" (click)="Reset()">Reset</button>
    </div>

    <nz-table [nzPageSize]="20" style="width: 100%;" nzBordered nzSize="small" #basicTable [nzData]="DocumentList"
      [nzLoading]="isTableLoading" [nzScroll]="{ y: '500px' }">
      <thead>
        <tr>
          <th nzWidth="50px"></th>
          <th nzWidth="50px">S.No.</th>
          <th nzWidth="200px">Document Name</th>
          <th nzWidth="150px">Document Code</th>
          <th nzWidth="120px">Format No</th>
          <th nzWidth="120px">Active Doc No</th>
          <th nzWidth="200px">Description</th>
          <th nzWidth="100px">Status</th>
          @if (permission.Edit || permission.Delete) {
            <th nzWidth="120px" style="text-align:center">Action
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (data of basicTable.data; track data; let i = $index) {
          <tr>
            <td [nzExpand]="data.ExpandRecord"
            (nzExpandChange)="data.ExpandRecord = $event; onExpandChange(data, $event)"></td>
            <td>{{ i + 1 }}</td>
            <td>{{data.DocumentName}}</td>
            <td>{{data.DocumentCode}}</td>
            <td>{{data.FormatNo}}</td>
            <td>{{data.ActiveDocumentNo}}</td>
            <td>{{data.Description}}</td>
            <td>
              <nz-tag [nzColor]="data.IsActive ? 'green' : 'red'" (click)="openTimeline(data)"
                style="cursor: pointer;" nz-tooltip nzTooltipTitle="Click to view history">
                {{data.IsActive ? 'Active' : 'Inactive'}}
              </nz-tag>
            </td>
            @if (permission.Edit || permission.Delete) {
              <td style="text-align:center">
                <button nz-button nz-dropdown [nzDropdownMenu]="documentTypeMenu" nzPlacement="bottomRight"
                  nzSize="small">
                  Actions <span nz-icon nzType="down"></span>
                </button>
                <nz-dropdown-menu #documentTypeMenu="nzDropdownMenu">
                  <ul nz-menu>
                    @if (permission.Edit) {
                      <li nz-menu-item (click)="OpenEditPop(data)">
                        <span nz-icon nzType="edit" nzTheme="outline"></span> Edit Type
                      </li>
                    }
                    @if (permission.Add) {
                      <li nz-menu-item (click)="openAddVersionModal(data)">
                        <span nz-icon nzType="plus-circle" nzTheme="outline"></span> Add Version
                      </li>
                    }
                    <li nz-menu-item (click)="openTimeline(data)">
                      <span nz-icon nzType="clock-circle" nzTheme="outline"></span> Timeline
                    </li>
                    @if (permission.Delete) {
                      <li nz-menu-divider></li>
                    }
                    @if (permission.Delete) {
                      <li nz-menu-item (click)="handleDelete(data)"
                        class="delete-item">
                        <span nz-icon nzType="delete" nzTheme="outline" style="color: #ff4d4f;"></span>
                        <span style="color: #ff4d4f;">Delete Type</span>
                      </li>
                    }
                  </ul>
                </nz-dropdown-menu>
              </td>
            }
          </tr>
          <tr [nzExpand]="data.ExpandRecord">
            <td colspan="8" style="padding: 0;">
              <nz-table #innerTable [nzData]="data.Versions || []" nzSize="small"
                [nzShowPagination]="false" style="margin: 0;">
                <thead>
                  <tr style="background: aliceblue;">
                    <th nzWidth="120px">Version No</th>
                    <th nzWidth="120px">Department</th>
                    <th nzWidth="120px">Effective Date</th>
                    <th nzWidth="120px">Review Date</th>
                    <th nzWidth="200px">Remark</th>
                    <th nzWidth="80px">Status</th>
                    <th nzWidth="150px">Added By</th>
                    <th nzWidth="150px" style="text-align:center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  @for (version of innerTable.data; track version) {
                    <tr>
                      <td>{{version.VersionNo}}</td>
                      <td>{{version.DepartmentName}}</td>
                      <td>{{version.EffectiveDate | DateConverter}}</td>
                      <td>{{version.ReviewDate | DateConverter}}</td>
                      <td>{{version.Remark}}</td>
                      <td>
                        <nz-tag [nzColor]="version.IsActive ? 'green' : 'red'">
                          {{version.IsActive ? 'Active' : 'Inactive'}}
                        </nz-tag>
                      </td>
                      <td>
                        <span style="font-size: 10px; display: block;">Created: {{version.CreatedByName}}</span>
                        @if (version.LastUpdatedByName) {
                          <span style="font-size: 10px; display: block;">
                            Updated: {{version.LastUpdatedByName}}
                          </span>
                        }
                      </td>
                      <td style="text-align:center">
                        <button nz-button nz-dropdown [nzDropdownMenu]="versionMenu" nzPlacement="bottomRight"
                          nzSize="small">
                          Actions <span nz-icon nzType="down"></span>
                        </button>
                        <nz-dropdown-menu #versionMenu="nzDropdownMenu">
                          <ul nz-menu>
                            @if (permission.Edit) {
                              <li nz-menu-item (click)="openEditVersionModal(version)">
                                <span nz-icon nzType="edit" nzTheme="outline"></span> Edit Version
                              </li>
                            }
                            @if (permission.Delete) {
                              <li nz-menu-divider></li>
                            }
                            @if (permission.Delete) {
                              <li nz-menu-item (click)="handleDeleteVersion(version)"
                                class="delete-item">
                                <span nz-icon nzType="delete" nzTheme="outline" style="color: #ff4d4f;"></span>
                                <span style="color: #ff4d4f;">Delete Version</span>
                              </li>
                            }
                          </ul>
                        </nz-dropdown-menu>
                      </td>
                    </tr>
                  }
                  @if (!data.Versions || data.Versions.length === 0) {
                    <tr>
                      <td colspan="7" style="text-align: center; color: #999;">
                        No versions available for this document type
                      </td>
                    </tr>
                  }
                </tbody>
              </nz-table>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>

    <nz-modal [(nzVisible)]="isVisible" [nzStyle]="{ top: '20px' }" [nzTitle]="PopUpTitle"
      (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()" [nzOkLoading]="isLoading">
      <ng-container *nzModalContent>
        <form nz-form [formGroup]="validateForm">
          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Document Name</nz-form-label>
            <nz-form-control [nzSpan]="14" nzErrorTip="Please select Document Name!">
              <div style="display: flex; align-items: center;">
                <nz-select formControlName="DocumentName" nzShowSearch
                  nzPlaceHolder="Select document type" (ngModelChange)="onDocumentTypeChange($event)"
                  style="flex-grow: 1;">
                  @for (docType of documentTypeOptions; track docType) {
                    <nz-option [nzValue]="docType.name"
                      [nzLabel]="docType.name">
                    </nz-option>
                  }
                </nz-select>
                @if (selectedDocumentDescription) {
                  <span nz-icon nzType="info-circle" nzTheme="outline"
                    nz-tooltip [nzTooltipTitle]="selectedDocumentDescription"
                  style="margin-left: 8px; color: #1890ff; cursor: help;"></span>
                }
              </div>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Format No</nz-form-label>
            <nz-form-control [nzSpan]="14" nzErrorTip="Please input Format No!">
              <input nz-input formControlName="FormatNo" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="8">Description</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <textarea nz-input formControlName="Description" rows="4"></textarea>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="8">Is Active</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <label nz-checkbox formControlName="IsActive"></label>
            </nz-form-control>
          </nz-form-item>
        </form>
      </ng-container>
    </nz-modal>

    <nz-modal [(nzVisible)]="isVersionModalVisible" [nzStyle]="{ top: '20px' }"
      [nzTitle]="isUpdate ? 'Edit Version' : 'Add New Version'" (nzOnCancel)="handleVersionCancel()"
      (nzOnOk)="handleVersionOk()" [nzOkLoading]="isLoading">
      <ng-container *nzModalContent>
        <form nz-form [formGroup]="validateVersionForm">
          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Document</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <input nz-input formControlName="DocumentName" readonly
                style="background-color: #f5f5f5;" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8">Format No</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <input nz-input formControlName="FormatNo" readonly style="background-color: #f5f5f5;" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8">Version No</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <input nz-input formControlName="VersionNo" placeholder="Auto-generated if left blank" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Department</nz-form-label>
            <nz-form-control [nzSpan]="14" nzErrorTip="Please select Department!">
              <nz-select formControlName="DepartmentId" nzShowSearch nzPlaceHolder="Select department">
                @for (dept of Departments; track dept) {
                  <nz-option [nzValue]="dept.DeptId"
                    [nzLabel]="dept.DeptName">
                  </nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Effective Date</nz-form-label>
            <nz-form-control [nzSpan]="14" nzErrorTip="Please select Effective Date!">
              <nz-date-picker formControlName="EffectiveDate" style="width: 100%;"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Review Date</nz-form-label>
            <nz-form-control [nzSpan]="14" nzErrorTip="Please select Review Date!">
              <nz-date-picker formControlName="ReviewDate" style="width: 100%;"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8">Remark</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <textarea nz-input formControlName="Remark" rows="2"
              placeholder="Reason for change..."></textarea>
            </nz-form-control>
          </nz-form-item>
        </form>
      </ng-container>
    </nz-modal>

    <!-- Timeline Modal -->
    <nz-modal [(nzVisible)]="isTimelineVisible" nzTitle="Document History" (nzOnCancel)="closeTimeline()"
      [nzFooter]="null" [nzWidth]="800">
      <ng-container *nzModalContent>
        <nz-spin [nzSpinning]="isTimelineLoading">
          <nz-timeline>
            @for (item of timelineData; track item) {
              <nz-timeline-item
                [nzColor]="item.Status === 'Active' ? 'green' : 'red'">
                <p>
                  <strong>{{item.ActionOn | date:'medium'}}</strong> - {{item.Action}}
                  @if (item.VersionNo) {
                    <span> (Version {{item.VersionNo}})</span>
                  }
                  by {{item.ActionByName}}
                </p>
                <p>{{item.Remarks}}</p>
              </nz-timeline-item>
            }
          </nz-timeline>
          @if (!isTimelineLoading && timelineData.length === 0) {
            <div
              style="text-align: center; padding: 20px;">
              No history found.
            </div>
          }
        </nz-spin>
      </ng-container>
    </nz-modal>
  </div>
</div>